import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormFields } from '../../../libs/hooksLib';
import { isNilOrEmpty } from '../../../utils/objectUtils';
import { Auth } from 'aws-amplify';
import { showNotificationError } from '../../../libs/errorLib';
import { useDispatch } from 'react-redux';

const useChangePassword = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [fields, handleFieldChange] = useFormFields({
        password: '',
        oldPassword: '',
        confirmPassword: '',
    });
    const [isChanging, setIsChanging] = useState(false);

    function validateForm() {
        return (
            !isNilOrEmpty(fields.oldPassword) &&
            !isNilOrEmpty(fields.password) &&
            fields.password === fields.confirmPassword
        );
    }

    async function handleChangeClick(
        event: React.MouseEvent<HTMLButtonElement>
    ) {
        event.preventDefault();

        setIsChanging(true);

        try {
            const currentUser = await Auth.currentAuthenticatedUser();
            await Auth.changePassword(
                currentUser,
                fields.oldPassword,
                fields.password
            );

            navigate('/settings');
        } catch (error) {
            showNotificationError(error.message, 'error', dispatch);
            setIsChanging(false);
        }
    }

    return {
        fields,
        handleFieldChange,
        handleChangeClick,
        isChanging,
        validateForm,
    };
};

export default useChangePassword;
